import { useState, useEffect } from "react";
import { API, axios } from "@/api";
import TieredPunchCard, { TIERS } from "./TieredPunchCard";

export default function TierLevelUpCelebration({ businessId, onDone }) {
  const [data, setData] = useState(null);
  const [show, setShow] = useState(false);
  const [fadeIn, setFadeIn] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const res = await axios.get(`${API}/punchcard/pending-celebration/${businessId}`);
        if (res.data?.pending_tier_celebration) {
          setData(res.data.pending_tier_celebration);
          setShow(true);
          setTimeout(() => setFadeIn(true), 100);
        }
      } catch { /* no celebration */ }
    })();
  }, [businessId]);

  const handleDone = async () => {
    try {
      await axios.post(`${API}/punchcard/clear-celebration/${businessId}`);
    } catch { /* ignore */ }
    setShow(false);
    onDone?.();
  };

  if (!show || !data) return null;

  const tier = data.new_tier || 1;
  const prevTier = Math.max(1, tier - 1);
  const t = TIERS[tier] || TIERS[1];
  const prevT = TIERS[prevTier] || TIERS[1];

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center bg-black/90 px-6" data-testid="tier-level-up-celebration">
      <div className="w-full max-w-sm text-center space-y-5">
        {/* Card with fade transition */}
        <div className="relative">
          {/* Previous tier card (fading out) */}
          <div
            className="absolute inset-0 transition-opacity duration-1000"
            style={{ opacity: fadeIn ? 0 : 1 }}
          >
            <TieredPunchCard
              tier={prevTier}
              punches_earned={0}
              punches_required={8}
              business_name="Level Up!"
              reward=""
            />
          </div>
          {/* New tier card (fading in) */}
          <div
            className="transition-opacity duration-1000"
            style={{ opacity: fadeIn ? 1 : 0 }}
          >
            <TieredPunchCard
              tier={tier}
              punches_earned={0}
              punches_required={8}
              business_name="Level Up!"
              reward=""
              is_animating_level_up={true}
            />
          </div>
        </div>

        {/* Tier name */}
        <h1
          className="text-3xl font-black"
          style={{ color: t.accent }}
          data-testid="celebration-tier-name"
        >
          {t.name} Level!
        </h1>

        {/* Points */}
        {data.points_awarded > 0 && (
          <p className="text-lg font-bold text-amber-400" data-testid="celebration-points">
            +{data.points_awarded} points
          </p>
        )}

        {/* Badge */}
        {data.badge_key && (
          <p className="text-sm text-white/60" data-testid="celebration-badge">
            {t.name} badge unlocked
          </p>
        )}

        {/* Done button */}
        <button
          onClick={handleDone}
          className="w-full py-4 rounded-xl bg-[#F59E0B] text-[#1C1C1E] font-black text-base active:scale-[0.98] transition"
          data-testid="celebration-done-btn"
        >
          Done
        </button>
      </div>
    </div>
  );
}
